// vms-find-mounts.js: the find-mounts page (URL state, lookup events, hand form, list, chips). Notes: assets/vms-find-mounts.notes.md
(function () {
  'use strict';
  var KEYS = ['tvm', 'tva', 'tvb', 'tvc', 'size', 'vesa', 'q'];
  var CHIPS = [['all', 'All'], ['ceiling_kit', 'Ceiling kits'], ['foldup', 'Fold-down'], ['dental', 'Dental'],
    ['fixed', 'Wall: fixed'], ['tilt', 'Wall: tilting'], ['full_motion', 'Wall: full-motion'], ['two_tv', 'Two TVs']];
  var SVGNS = 'http://www.w3.org/2000/svg';
  var WEIGHT = 'Check your TV\'s weight. We don\'t have it in our data. Each mount below lists its weight rating.';
  var WEIGHT_HAND = 'Check your TV\'s weight against each mount\'s rating.';
  var MORE = { ceiling: ['ceiling mount', 'ceiling mounts'], wall: ['wall mount', 'wall mounts'], two_tv: ['two-TV mount', 'two-TV mounts'] };

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function money(n) { return '$' + Number(n).toFixed(2); }
  function norm(v) { return String(v == null ? '' : v).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function fmtN(x) { return String(Math.round(Number(x) * 100) / 100); }
  function lb1(x) { return Number(x).toFixed(1); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function joinAnd(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function readLinks(node) {
    var out = { models: {}, brands: {} }, d = null;
    try { d = JSON.parse(node ? node.textContent : ''); } catch (e) { return out; }
    ['models', 'brands'].forEach(function (g) {
      var src = d && d[g];
      if (src && typeof src === 'object') Object.keys(src).forEach(function (k) { out[g][norm(k)] = src[k]; });
    });
    return out;
  }
  function tvPages(L, model, brand) {
    var m = L && L.models[norm(model)] || null, b = L && (L.brands[norm(brand)] || (m && L.brands[norm(m.b)])) || null;
    return { series: m && m.u ? { href: m.u, text: 'See every mount for the ' + m.n } : null, brand: b && b.u ? { href: b.u, text: b.t } : null };
  }

  function headline(res, F) {
    var tv = res && res.tv, k = res && res.counts;
    if (!tv || res.state !== 'result' || tv.vesaW == null || tv.vesaH == null) return null;
    var n = k.one_tv_total, kinds = [], figs = [fmtN(tv.vesaW) + ' x ' + fmtN(tv.vesaH) + ' mm hole pattern'];
    if (k.ceiling) kinds.push(plural(k.ceiling, 'ceiling mount', 'ceiling mounts'));
    if (k.wall) kinds.push(plural(k.wall, 'wall mount', 'wall mounts'));
    if (tv.weightLb != null) figs.push(lb1(tv.weightLb) + ' lb weight');
    if (tv.sizeIn != null) figs.push(tv.sizeIn + ' inch screen');
    return { heading: (n === 1 ? '1 mount fits' : n + ' mounts fit') + ' this TV', sub: joinAnd(kinds) + ' ' + (n === 1 ? 'matches' : 'match') + ' its ' + joinAnd(figs) + '.', weight: tv.weightLb != null ? '' : tv.source === 'catalog' ? WEIGHT : WEIGHT_HAND };
  }

  function fitRows(r, F) {
    var c = r.checks, t = F.copy.lines(r), v = c.vesa, w = c.weight, z = c.size, out = [], x = r.rails;
    out.push(v.ok ? { k: 'holes', st: 'ok', label: 'Holes', value: span(v.mount.w) + ' x ' + span(v.mount.h) + ' mm', text: t[0] }
      : { k: 'holes', st: 'nc', label: 'Holes', value: 'not checked', text: t[0] });
    out.push(w.ok ? { k: 'load', st: 'ok', label: 'Load', value: lb1(w.tv) + ' of ' + fmtN(w.mount) + ' lb', text: t[1] }
      : r.fit === 'check_weight' ? { k: 'load', st: 'warn', label: 'Load', value: 'rated ' + fmtN(w.mount) + ' lb, check yours', text: t[1] }
      : { k: 'load', st: 'nc', label: 'Load', value: 'not checked', text: t[1] });
    if (z.ok && z.railsMax && z.tv > z.mount[1]) out.push({ k: 'screen', st: 'note', label: 'Screen', text: t[2] });
    else if (z.ok) out.push({ k: 'screen', st: 'ok', label: 'Screen', value: z.tv + ' in, made for ' + fmtN(z.mount[0]) + ' to ' + fmtN(z.mount[1]) + ' in', phone: fmtN(z.mount[0]) + ' to ' + fmtN(z.mount[1]) + ' in screens', text: t[2] });
    else out.push({ k: 'screen', st: 'nc', label: 'Screen', value: 'not checked', text: t[2] });
    if (x) {
      if (x.needed === false && x.total_mm != null) out.push({ k: 'rails', st: 'ok', label: 'Top to lower holes', value: x.unit === 'in' ? x.total_in + ' of ' + (Math.round(x.reach_mm / 25.4 * 10) / 10) + ' in' : Math.round(x.total_mm) + ' of ' + x.reach_mm + ' mm', text: t[3] });
      else out.push({ k: 'rails', st: 'note', label: 'Top to lower holes', text: t[3], order: x.free === false && x.needed !== false });
    }
    return out;
  }

  function span(a) { return a[0] === a[1] ? String(a[0]) : a[0] + ' to ' + a[1]; }
  var SCOPE = { wall: 1, ceiling: 1 };
  function onChip(chip, g, sub) { return chip === 'all' ? sub !== 'two_tv' : SCOPE[chip] ? g === chip : sub === chip; }
  function firstShown(groups, chip, lim, n) {
    var out = [];
    ['ceiling', 'wall', 'two_tv'].forEach(function (g) {
      var on = groups[g].filter(function (r) { return onChip(chip, g, r.sub); });
      out = out.concat(on.slice(0, shown(on.length, lim, false)));
    });
    return out.slice(0, n);
  }
  function shown(n, lim, open) { return open || n <= lim ? n : lim; }
  function moreText(n, g) { var w = MORE[g] || MORE.wall; return 'Show ' + n + ' more ' + (n === 1 ? w[0] : w[1]); }
  var SLUG = { ceiling_kit: 'ceiling-kits', foldup: 'fold-down', dental: 'dental', fixed: 'wall-fixed', tilt: 'wall-tilting', full_motion: 'wall-full-motion', two_tv: 'two-tvs', wall: 'wall', ceiling: 'ceiling' };
  var IMG_W = [200, 300, 400, 600];
  var HOLD_EV = ['pointerdown', 'touchstart', 'keydown'];
  var CODE = '33FD-ADAPT';
  function keepCode(node, text) {
    node.textContent = text;
    var t = node.firstChild, i;
    while (t && t.splitText && (i = t.data.indexOf(CODE)) !== -1) {
      var mid = t.splitText(i), rest = mid.splitText(CODE.length), s = el('span', 'vms-fm__nw');
      node.replaceChild(s, mid);
      s.appendChild(mid);
      t = rest;
    }
    return node;
  }
  var SIZES = '(max-width: 767px) 100px, (max-width: 1279px) 300px, 220px';
  function tvId(p) { return ['tvm', 'tva', 'tvb', 'tvc', 'vesa'].map(function (k) { return p.get(k) || ''; }).join('|'); }
  function chipOf(slug) { for (var k in SLUG) if (SLUG[k] === slug) return k; return null; }
  function srcset(u) {
    if (typeof u !== 'string' || !/[?&]width=\d+/.test(u)) return '';
    return IMG_W.map(function (w) { return u.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
  }
  function stickyFits(colH, viewH, stuckH, gap) { return colH > 0 && viewH > 0 && colH + (stuckH || 0) + 2 * (gap || 0) <= viewH; }

  function icon(id, cls) {
    var s = el('span', cls || 'vms-fm__ic');
    if (!document.createElementNS) return s;
    var svg = document.createElementNS(SVGNS, 'svg'), u = document.createElementNS(SVGNS, 'use');
    svg.setAttribute('width', '13'); svg.setAttribute('height', '13'); svg.setAttribute('focusable', 'false'); svg.setAttribute('aria-hidden', 'true');
    u.setAttribute('href', '#' + id);
    svg.appendChild(u); s.appendChild(svg);
    return s;
  }
  function val(cls, text) {
    var s = el('span', cls);
    s.setAttribute('aria-hidden', 'true');
    var parts = String(text).split(' x ');
    if (parts.length < 2) { s.textContent = String(text); return s; }
    parts.forEach(function (p, i) { if (i) s.appendChild(document.createTextNode(' x ')); s.appendChild(el('span', 'vms-fm__nw', p)); });
    return s;
  }

  function readData(F) {
    var s = document.getElementById('vms-find-mounts-data');
    try { return F.expand(JSON.parse(s ? s.textContent : '')); } catch (e) { return null; }
  }

  function Page(root, data, F) {
    this.root = root; this.data = data; this.F = F;
    this.cfg = data.page_config || {};
    this.q = function (sel) { return root.querySelector(sel); };
    this.tv = null; this.res = null; this.chip = 'all'; this.urlSize = null; this.arrTerm = null; this.unit = 'mm'; this.row = null;
    this.open = {}; this.busy = false; this.n = 0; this.probe = null; this.pendChip = null; this.asked = false; this.raf = 0;
    this.mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    this.wide = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
    this.popping = false; this.hold = false; this.holdOff = null; this.pendOpen = null;
    this.lookupRoot = root.querySelector('[data-vms-tvl]');
    this.links = readLinks(root.querySelector('[data-vms-tvlinks]'));
    var inp = this.lookupRoot && this.lookupRoot.querySelector('[data-tvl-input]');
    if (inp) { inp.setAttribute('autocorrect', 'off'); inp.setAttribute('enterkeyhint', 'search'); inp.setAttribute('translate', 'no'); }
    this.capGuard(data);
    this.bind();
    this.arrive();
    this.layout();
  }

  Page.prototype.withPhone = function (node, text) {
    var ph = this.cfg.phone, tel = this.cfg.phone_tel, i = ph ? text.indexOf(ph) : -1;
    node.textContent = '';
    if (i < 0 || !tel) { node.textContent = text; return node; }
    var a = el('a', null, ph);
    a.href = 'tel:' + tel;
    node.appendChild(document.createTextNode(text.slice(0, i)));
    node.appendChild(a);
    node.appendChild(document.createTextNode(text.slice(i + ph.length)));
    return node;
  };

  Page.prototype.capGuard = function (data) {
    var c = data.counts || {}, t = data.totals || {}, over = [];
    ['ceiling', 'wall'].forEach(function (k) { if (typeof t[k] === 'number' && typeof c[k] === 'number' && t[k] > c[k]) over.push(k + ' ' + c[k] + ' of ' + t[k]); });
    if (!over.length) return;
    this.root.setAttribute('data-cap-exceeded', over.join(', '));
    console.warn('vms-find-mounts: collection loop capped, mounts missing (' + over.join(', ') + ')');
  };

  Page.prototype.widget = function (cb, tries) {
    var self = this, w = this.lookupRoot && this.lookupRoot.vmsTvl;
    if (w) return cb(w);
    if ((tries || 0) < 20) { setTimeout(function () { self.widget(cb, (tries || 0) + 1); }, 100); return; }
    this.dropArrival();
    this.wait(false);
    var n = this.q('[data-fm-note]');
    n.textContent = 'Lookup is unavailable for a moment. You can still enter the details by hand.';
    n.hidden = false;
    this.announce(n.textContent);
    this.openHand();
  };

  Page.prototype.dropArrival = function () {
    if (this.arrTerm == null) return;
    this.urlSize = null; this.arrTerm = null; this.pendChip = null;
    if (!this.tv) this.writeUrl();
  };

  Page.prototype.bind = function () {
    var self = this, lr = this.lookupRoot;
    if (lr) {
      lr.addEventListener('vms:tv-selected', function (e) {
        var d = e.detail || {}, a = self.arrTerm;
        var hit = a != null && (norm(d.query) === a || norm(d.model_number) === a), size = hit ? self.urlSize : null;
        if (!hit) self.pendChip = null;
        self.asked = false;
        self.urlSize = null; self.arrTerm = null;
        self.row = d;
        self.note(null);
        self.set(self.F.tvFromRow(d, { size: size }), d.explicit === true);
      });
      lr.addEventListener('vms:tv-cleared', function () {
        if (!self.popping && self.tv && self.tv.source === 'catalog') self.set(null, false);
      });
      var box = lr.querySelector('[data-tvl-input]'), form = lr.querySelector('[data-tvl-form]');
      lr.addEventListener('input', function (e) {
        if (e && e.target && e.target !== box) return;
        self.asked = false;
        self.dropArrival();
        if (!self.tv) self.wait(false, true);
      });
      lr.addEventListener('submit', function (e) {
        if (e && e.target && e.target !== form) return;
        self.asked = !!box && String(box.value || '').trim().length >= 2;
      }, true);
      var out = lr.querySelector('[data-tvl-out]');
      if (out && window.MutationObserver) new MutationObserver(function () { self.watchOut(out); }).observe(out, { childList: true });
    }
    this.q('[data-fm-change]').addEventListener('click', function () { self.change(); });
    this.q('[data-fm-hand-form]').addEventListener('submit', function (e) { e.preventDefault(); self.hand(); });
    this.q('[data-fm-size]').addEventListener('change', function () { self.sizePicked(); });
    this.root.querySelectorAll('[data-fm-unit]').forEach(function (b) {
      b.addEventListener('click', function () { self.setUnit(b.getAttribute('data-fm-unit')); });
    });
    this.root.querySelectorAll('[data-fm-more]').forEach(function (b) {
      b.addEventListener('click', function () { self.more(b.getAttribute('data-fm-more')); });
    });
    var mq = this.mq, re = function () { if (self.res) self.filter(); };
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', re); else if (mq.addListener) mq.addListener(re); }
    var left = this.q('[data-fm-left]'), st = function () {
      if (!window.requestAnimationFrame) return self.stick();
      if (!self.raf) self.raf = window.requestAnimationFrame(function () { self.raf = 0; self.stick(); });
    };
    if (window.addEventListener) window.addEventListener('popstate', function () { self.fromHistory(); });
    if (window.ResizeObserver && left) new ResizeObserver(st).observe(left);
    if (window.addEventListener) window.addEventListener('resize', st);
  };

  Page.prototype.watchOut = function (out) {
    if (out.querySelector('.vms-tvl__card')) return;
    var t = out.textContent || '';
    if (t.indexOf('We do not have that model') !== -1) { this.dropArrival(); this.wait(false); this.note('none'); this.openHand(); this.errFocus(out); }
    else if (t.indexOf('Lookup is unavailable') !== -1) { this.dropArrival(); this.wait(false); this.note('unavailable'); this.openHand(); this.errFocus(out); }
    else if (t.indexOf('Looking it up') !== -1) { if (!this.tv && this.arrTerm != null) this.wait(true); }
    else { this.asked = false; this.wait(false); this.note(null); }
  };

  Page.prototype.errFocus = function (out) {
    var m = this.asked && out.querySelector('.vms-tvl__msg');
    this.asked = false;
    if (!m) return;
    m.tabIndex = -1;
    m.focus();
  };

  Page.prototype.note = function (kind) {
    var n = this.q('[data-fm-note]');
    if (!kind) { n.hidden = true; n.textContent = ''; return; }
    this.withPhone(n, this.F.copy.answer(kind, null, this.cfg.phone));
    n.hidden = false;
    this.announce(n.textContent);
  };

  Page.prototype.openHand = function (size) {
    if (this.hold) { this.pendOpen = size != null ? size : true; return; }
    var d = this.q('[data-fm-hand]');
    d.open = true;
    if (size != null) this.q('[data-fm-size]').value = String(size);
  };

  Page.prototype.setUnit = function (u) {
    if (u === this.unit) return;
    this.unit = u;
    var re = /^\d+(\.\d+)?$/;
    ['[data-fm-w]', '[data-fm-h]'].forEach(function (sel) {
      var i = this.q(sel), v = i.value.trim();
      if (!re.test(v)) return;
      i.value = u === 'in' ? String(Math.round(Number(v) / 25.4 * 10) / 10) : String(Math.round(Number(v) * 25.4));
    }, this);
    this.root.querySelectorAll('[data-fm-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fm-unit') === u ? 'true' : 'false'); });
    this.root.querySelectorAll('[data-fm-unit-label]').forEach(function (s) { s.textContent = u; });
  };

  Page.prototype.arrive = function (pop, search) {
    var F = this.F, p = new URLSearchParams(search != null ? search : location.search);
    var tv = F.tvFromParams(p);
    this.pendChip = chipOf(p.get('chip'));
    if (tv && tv.source === 'manual') { this.set(tv, false); return; }
    var m = (p.get('tvm') || '').trim(), qq = (p.get('q') || '').trim(), term = m || qq;
    if (term && term.length <= 64) {
      var s = p.get('size');
      this.urlSize = s && /^\d+(\.\d+)?$/.test(s.trim()) ? Math.round(Number(s)) : null;
      this.arrTerm = norm(term);
      this.busy = true;
      this.widget(function (w) { w.input.value = term; w.lookup(term, false, { prefill: true }); });
      return;
    }
    if (!tv && !KEYS.some(function (k) { return p.get(k); }) && (pop ? (this.set(null, false), true) : this.saved())) return;
    if (tv) {
      if (tv.sizeIn != null) this.q('[data-fm-size]').value = String(tv.sizeIn);
      if (p.get('vesa') && tv.vesaW == null) { this.openHand(); this.err(true); }
      this.set(tv, false);
    } else if (p.get('vesa')) { this.openHand(); this.err(true); }
  };

  Page.prototype.fromHistory = function () {
    var p = new URLSearchParams(location.search), kv = this.F.pageParams(this.tv), want = chipOf(p.get('chip')) || 'all';
    var same = kv.length === KEYS.filter(function (k) { return p.get(k); }).length && kv.every(function (x) { return p.get(x[0]) === x[1]; });
    if (same) {
      if (!this.tv || want === this.chip || !this.chipCount(want)) return;
      this.chip = want; this.open = {};
      this.pressChips();
      this.announce(plural(this.filter(), 'mount shown.', 'mounts shown.'));
      return;
    }
    var search = location.search;
    this.popping = true;
    this.urlSize = null; this.arrTerm = null; this.pendChip = null;
    this.tv = null; this.res = null; this.chip = 'all'; this.open = {};
    this.widget(function (w) { clearTimeout(w.timer); w.abort(); w.clear(); w.input.value = ''; });
    try { this.arrive(true, search); } finally { this.popping = false; }
    if (!this.tv) this.render();
    this.layout();
  };

  Page.prototype.chipCount = function (k) {
    var c = this.res && this.res.counts;
    return c ? (k === 'all' ? c.one_tv_total : c[k]) || 0 : 0;
  };

  Page.prototype.pressChips = function () {
    var chip = this.chip;
    this.root.querySelectorAll('[data-fm-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-fm-chip') === chip ? 'true' : 'false'); });
  };

  Page.prototype.saved = function () {
    var S = window.VMSSavedTv, rec = S && S.get();
    if (!rec) return false;
    if (rec.source === 'catalog') {
      this.urlSize = rec.opt && rec.opt.size != null ? rec.opt.size : null;
      this.arrTerm = norm(rec.row.model_number);
      this.busy = true;
      this.widget(function (w) { w.renderRow(rec.row, { prefill: true, catalog_version: rec.catalog_version }); });
      return true;
    }
    var tv = S.toTv(rec, this.F);
    if (!tv) return false;
    if (tv.sizeIn != null) this.q('[data-fm-size]').value = String(tv.sizeIn);
    if (tv.vesaW != null) { this.q('[data-fm-w]').value = String(tv.vesaW); this.q('[data-fm-h]').value = String(tv.vesaH); }
    this.set(tv, false);
    return true;
  };

  Page.prototype.chosen = function (detail) {
    try { this.root.dispatchEvent(new CustomEvent('vms:tv-chosen', { bubbles: true, detail: detail })); } catch (e) {}
  };

  Page.prototype.err = function (on) {
    var e = this.q('[data-fm-err]');
    e.textContent = on ? this.F.copy.answer('hand_error') : '';
    e.hidden = !on;
  };

  Page.prototype.hand = function () {
    var F = this.F, size = this.q('[data-fm-size]').value, w = this.q('[data-fm-w]').value.trim(), h = this.q('[data-fm-h]').value.trim();
    var k = this.unit === 'in' ? 25.4 : 1, re = /^\d+(\.\d+)?$/;
    var wn = re.test(w) ? Number(w) * k : 0, hn = re.test(h) ? Number(h) * k : 0;
    if (!(wn > 0 && hn > 0)) { this.err(true); this.q('[data-fm-w]').focus(); return; }
    this.err(false);
    var tv = F.tvFromParams({ size: size, vesa: F.snapVesa(wn) + 'x' + F.snapVesa(hn) });
    this.widget(function (wd) { clearTimeout(wd.timer); wd.abort(); wd.clear(); wd.input.value = ''; });
    this.note(null);
    this.set(tv, true);
    this.chosen({ source: 'hand', size: tv.sizeIn, vesa_width_mm: tv.vesaW, vesa_height_mm: tv.vesaH });
  };

  Page.prototype.sizePicked = function () {
    var v = this.q('[data-fm-size]').value, tv = this.tv;
    if (!tv || tv.source === 'hand' || tv.state === 'proprietary' || !v) return;
    var n = Number(v);
    if (tv.source === 'catalog') { tv.sizeIn = n; tv.sizeOverride = tv.rowSize != null && n !== tv.rowSize; }
    else tv.sizeIn = n;
    this.set(tv, false);
    if (tv.source === 'catalog' && this.row && this.row.explicit === true) this.chosen({ source: 'catalog', row: this.row, size: n });
  };

  Page.prototype.change = function () {
    this.set(null, false);
    this.note(null);
    this.err(false);
    this.widget(function (w) { clearTimeout(w.timer); w.abort(); w.clear(); w.input.value = ''; w.input.focus(); });
  };

  Page.prototype.writeUrl = function (push) {
    if (this.popping || !window.history || !history.replaceState) return;
    var p = new URLSearchParams(location.search), was = tvId(p);
    KEYS.forEach(function (k) { p.delete(k); });
    p.delete('chip');
    this.F.pageParams(this.tv).forEach(function (kv) { p.append(kv[0], kv[1]); });
    if (this.tv && this.chip !== 'all' && SLUG[this.chip]) p.append('chip', SLUG[this.chip]);
    var s = p.toString(), u = location.pathname + (s ? '?' + s : '') + location.hash;
    if (/[^|]/.test(was) && was !== tvId(p)) push = true;
    try { if (push && history.pushState) history.pushState(history.state, '', u); else history.replaceState(history.state, '', u); } catch (e) {}
  };

  Page.prototype.set = function (tv, explicit) {
    var arrived = this.busy;
    if (this.hold) this.release(true);
    this.tv = tv;
    this.chip = 'all';
    this.open = {};
    this.busy = false;
    this.res = tv ? this.F.matchAll(tv, this.data, { builderUrl: this.cfg.builder_url }) : null;
    if (arrived && !(this.res && (this.res.state === 'result' || this.res.state === 'need_size'))) this.holdOn();
    var want = this.pendChip;
    this.pendChip = null;
    if (want && tv && this.chipCount(want)) this.chip = want;
    this.writeUrl();
    this.render(explicit && tv);
    if (explicit && tv) this.q('[data-fm-say]').focus();
  };

  Page.prototype.wait = function (on, user) {
    if (this.busy === !!on) return;
    this.busy = !!on;
    if (!on && !user) this.holdOn();
    this.layout();
  };

  Page.prototype.holdOn = function () {
    var self = this, w = window;
    if (this.hold || !w.addEventListener) return;
    this.hold = true;
    this.holdOff = function () { self.release(); };
    HOLD_EV.forEach(function (t) { w.addEventListener(t, self.holdOff, { capture: true, passive: true }); });
  };

  Page.prototype.release = function (quiet) {
    var w = window, f = this.holdOff, s = this.pendOpen;
    if (!this.hold) return;
    this.hold = false; this.holdOff = null; this.pendOpen = null;
    if (f && w.removeEventListener) HOLD_EV.forEach(function (t) { w.removeEventListener(t, f, { capture: true }); });
    if (quiet) return;
    this.layout();
    if (s) this.openHand(s === true ? null : s);
  };

  Page.prototype.layout = function () {
    var tv = this.tv, busy = this.busy && !tv, hold = this.hold;
    this.root.classList.toggle('is-tv', !!tv);
    this.root.classList.toggle('is-split', !!tv || busy || hold);
    this.root.classList.toggle('is-busy', busy);
    this.root.classList.toggle('is-hold', hold);
    if (this.root.removeAttribute) this.root.removeAttribute('data-fm-arrive');
    this.q('[data-fm-result]').hidden = !tv && !busy && !hold;
    this.q('[data-fm-skel]').hidden = !busy;
    this.q('[data-fm-body]').hidden = !tv;
    this.placeHand();
    this.stick();
  };

  Page.prototype.placeHand = function () {
    var hand = this.q('[data-fm-hand]'), lk = this.q('[data-fm-lookup]'), out = this.lookupRoot && this.lookupRoot.querySelector('[data-tvl-out]');
    if (!hand || !lk || !out) return;
    var on = !!this.tv || this.busy || this.hold, box = on ? out.parentNode : lk.parentNode;
    if (!box || !box.insertBefore || hand.parentNode === box) return;
    box.insertBefore(hand, on ? out : lk.nextSibling);
  };

  Page.prototype.stuckH = function () {
    if (!this.probe) { this.probe = el('div', 'vms-fm__probe'); this.probe.setAttribute('aria-hidden', 'true'); this.root.appendChild(this.probe); }
    return this.probe.offsetHeight || 0;
  };

  Page.prototype.stick = function () {
    var left = this.q('[data-fm-left]'), vh = window.innerHeight;
    if (!left) return;
    left.classList.toggle('is-sticky', !!this.tv && !!vh && stickyFits(left.offsetHeight || 0, vh, this.stuckH(), 16));
  };

  Page.prototype.announce = function (text) {
    var s = this.q('[data-fm-status]');
    if (s) s.textContent = text || '';
  };

  Page.prototype.render = function (focused) {
    var F = this.F, res = this.res, tv = this.tv;
    this.layout();
    var bar = this.q('[data-fm-bar]'), how = this.q('[data-fm-how]'), ver = this.q('[data-fm-ver]');
    bar.hidden = !tv || tv.source === 'catalog';
    if (!tv) { how.hidden = false; ver.hidden = true; ver.textContent = ''; return; }
    if (!bar.hidden) this.q('[data-fm-bar-text]').textContent = F.copy.barParts(tv).join(' | ') + ' | ';
    var st = res.state, ph = this.cfg.phone, hl = headline(res, F);
    var rh = this.q('[data-fm-rh]');
    rh.textContent = hl ? hl.heading : '';
    rh.hidden = !hl;
    var sent = hl ? hl.sub : F.copy.sentence(res), sn = this.q('[data-fm-sentence]');
    sn.textContent = sent; sn.hidden = !sent;
    sn.classList.toggle('is-sub', !!hl);
    var wt = this.q('[data-fm-weight]'), wtt = this.q('[data-fm-weight-text]') || wt;
    wtt.textContent = hl ? hl.weight : ''; wt.hidden = !(hl && hl.weight);
    var two = F.copy.twoTvNote(res), tn = this.q('[data-fm-two]');
    tn.textContent = two; tn.hidden = !two;
    var tp = tv.source === 'catalog' && this.row ? tvPages(this.links, this.row.model_norm || this.row.model_number, this.row.manufacturer) : {};
    ['series', 'brand'].forEach(function (k) {
      var p = this.q('[data-fm-tvp="' + k + '"]'), a = p && p.querySelector('a'), x = tp[k];
      if (!a) return;
      a.textContent = x ? x.text : '';
      a.setAttribute('href', x ? x.href : '#');
      p.hidden = !x;
    }, this);
    var ans = this.q('[data-fm-answer]'), kind = null;
    if (st === 'proprietary' || st === 'no_vesa' || st === 'zero') kind = st;
    else if (st === 'need_size' || (st === 'need_input' && tv.source === 'manual')) kind = 'need_size';
    if (kind) this.withPhone(ans, F.copy.answer(kind, res, ph)); else ans.textContent = '';
    ans.hidden = !kind;
    this.q('[data-fm-adapter]').hidden = !(st === 'zero' && res.zeroReason === 'holes');
    if (st === 'no_vesa') this.openHand(tv.sizeIn);
    if (kind === 'need_size') this.openHand();
    var listed = st === 'result' || st === 'need_size' || st === 'zero';
    this.renderTop(listed && st !== 'need_size' || (res.builder.show && st !== 'proprietary'));
    this.renderChips(listed && !!(res.counts.one_tv_total || res.counts.two_tv));
    this.renderLists(listed);
    how.hidden = !listed;
    ver.textContent = tv.catalogVersion ? 'TV list version: ' + tv.catalogVersion + '.' : '';
    ver.hidden = !tv.catalogVersion;
    if (!focused) this.announce(hl ? hl.heading : (sent || ans.textContent || ''));
  };

  Page.prototype.renderTop = function (show) {
    var res = this.res, k = res.counts, top = this.q('[data-fm-top]');
    top.hidden = !show;
    if (!show) return;
    var b = this.q('[data-fm-build]');
    b.hidden = !res.builder.show;
    if (res.builder.show) this.q('[data-fm-build-link]').setAttribute('href', res.builder.url);
    var ov = this.q('[data-fm-override]');
    ov.textContent = res.builder.note ? this.F.copy.answer('override') : '';
    ov.hidden = !res.builder.note;
    [['[data-fm-kits]', '[data-fm-kits-count]', k.ceiling], ['[data-fm-walls]', '[data-fm-walls-count]', k.wall]].forEach(function (t) {
      var card = this.q(t[0]), p = this.q(t[1]);
      card.classList.toggle('is-zero', !t[2]);
      p.textContent = '';
      if (t[2]) { p.appendChild(el('span', 'vms-fm__n', String(t[2]))); p.appendChild(el('span', 'vms-fm__nt', t[2] === 1 ? ' fits this TV' : ' fit this TV')); }
      else p.textContent = 'None fit this TV';
    }, this);
    this.tiles();
  };

  Page.prototype.tiles = function () {
    var res = this.res, listed = !!res && (res.state === 'result' || res.state === 'zero'), sc = SCOPE[this.chip] ? this.chip : null;
    [['[data-fm-kits]', 'ceiling'], ['[data-fm-walls]', 'wall']].forEach(function (t) { var c = this.q(t[0]); if (c) c.hidden = !listed || (!!sc && sc !== t[1]); }, this);
  };

  Page.prototype.renderChips = function (show) {
    var self = this, box = this.q('[data-fm-chips]'), k = this.res.counts;
    box.textContent = '';
    this.q('[data-fm-filters]').hidden = !show;
    if (!show) return;
    CHIPS.forEach(function (c) {
      var n = c[0] === 'all' ? k.one_tv_total : k[c[0]];
      var b = el('button', 'vms-fm__chip', c[1] + ' (' + n + ')');
      b.type = 'button';
      b.setAttribute('data-fm-chip', c[0]);
      b.setAttribute('aria-pressed', self.chip === c[0] ? 'true' : 'false');
      if (!n) { b.disabled = true; b.classList.add('is-zero'); }
      b.addEventListener('click', function () {
        if (!n || self.chip === c[0]) return;
        self.chip = c[0];
        self.open = {};
        box.querySelectorAll('[data-fm-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var total = self.filter();
        self.writeUrl(true);
        self.announce(plural(total, 'mount shown.', 'mounts shown.'));
      });
      box.appendChild(b);
    });
  };

  Page.prototype.fit = function (r) {
    var self = this, ul = el('ul', 'vms-fm__checks');
    ul.setAttribute('role', 'list');
    fitRows(r, this.F).forEach(function (x) {
      var li;
      if (x.st === 'note') {
        li = keepCode(el('li', 'vms-fm__fr vms-fm__fr--note vms-fm__fr--' + x.k), x.text);
        if (x.order) {
          var ra = el('a', null, 'Order the adapter rails');
          ra.href = self.F.railsUrl(self.tv);
          li.appendChild(document.createTextNode(' '));
          li.appendChild(ra);
        }
      } else {
        li = el('li', 'vms-fm__fr vms-fm__fr--' + x.k + (x.st === 'nc' ? ' is-nc' : x.st === 'warn' ? ' is-warn' : ''));
        var fl = el('span', 'vms-fm__fl');
        fl.setAttribute('aria-hidden', 'true');
        fl.appendChild(icon(x.st === 'ok' ? 'vms-fm-ck' : x.st === 'warn' ? 'vms-fm-warn' : 'vms-fm-nc'));
        fl.appendChild(el('span', 'vms-fm__lab', x.label));
        li.appendChild(fl);
        li.appendChild(val('vms-fm__fv', x.value));
        if (x.phone) li.appendChild(val('vms-fm__fvp', x.phone));
        li.appendChild(el('span', 'visually-hidden', x.text));
      }
      ul.appendChild(li);
    });
    return ul;
  };

  Page.prototype.card = function (r, eager) {
    var m = r.mount, li = el('li', 'vms-fm__card'), id = 'vms-fm-c' + (++this.n);
    li.setAttribute('data-sub', r.sub);
    li.setAttribute('data-handle', m.handle);
    li.setAttribute('data-fit', r.fit);
    if (m.image) {
      var img = el('img', 'vms-fm__img');
      img.src = m.image; img.alt = ''; img.loading = eager ? 'eager' : 'lazy'; img.decoding = 'async'; img.width = 200; img.height = 200;
      var set = srcset(m.image);
      if (set) { img.setAttribute('srcset', set); img.setAttribute('sizes', SIZES); }
      li.appendChild(img);
    }
    var h = el('h3', 'vms-fm__title'), a = el('a', 'vms-fm__stretch', m.title);
    a.href = m.url;
    a.setAttribute('aria-describedby', (m.price != null ? id + '-p ' : '') + id + '-f');
    h.appendChild(a); li.appendChild(h);
    if (m.price != null) {
      var p = el('p', 'vms-fm__price', (m.price_max != null ? 'From ' : '') + money(m.price));
      p.id = id + '-p';
      li.appendChild(p);
    }
    var ul = this.fit(r);
    ul.id = id + '-f';
    li.appendChild(ul);
    var v = el('span', 'vms-fm__view', 'View this mount');
    v.setAttribute('aria-hidden', 'true');
    v.appendChild(icon('vms-fm-chev', 'vms-fm__chev'));
    li.appendChild(v);
    return li;
  };

  Page.prototype.renderLists = function (show) {
    var self = this, wrap = this.q('[data-fm-lists]');
    wrap.hidden = !show;
    var eager = this.wide && this.wide.matches ? firstShown(this.res.groups, this.chip, this.limit(), 3) : [];
    ['ceiling', 'wall', 'two_tv'].forEach(function (g) {
      var ul = self.q('[data-fm-cards="' + g + '"]');
      ul.textContent = '';
      if (show) self.res.groups[g].forEach(function (r) { ul.appendChild(self.card(r, eager.indexOf(r) !== -1)); });
    });
    if (show) this.filter();
  };

  Page.prototype.limit = function () { return this.mq && this.mq.matches ? 3 : 6; };

  Page.prototype.filter = function () {
    var chip = this.chip, lim = this.limit(), open = this.open, total = 0;
    this.root.querySelectorAll('[data-fm-group]').forEach(function (sec) {
      var g = sec.getAttribute('data-fm-group'), on = [];
      sec.querySelectorAll('.vms-fm__card').forEach(function (li) {
        var s = li.getAttribute('data-sub');
        if (onChip(chip, g, s)) on.push(li); else li.hidden = true;
      });
      var cut = shown(on.length, lim, open[g]);
      on.forEach(function (li, i) { li.hidden = i >= cut; });
      total += cut;
      sec.hidden = !on.length;
      var pill = sec.querySelector('[data-fm-pill]'), wrap = sec.querySelector('[data-fm-more-wrap]'), btn = sec.querySelector('[data-fm-more]');
      if (pill) pill.textContent = on.length + ' fit';
      if (wrap && btn) {
        wrap.hidden = on.length <= cut;
        btn.setAttribute('aria-expanded', on.length > cut ? 'false' : 'true');
        btn.textContent = on.length > cut ? moreText(on.length - cut, g) : '';
      }
    });
    var k = this.res ? this.res.counts : {};
    if (this.res) this.tiles();
    this.root.querySelectorAll('[data-fm-jump]').forEach(function (a) {
      var g = a.getAttribute('data-fm-jump'), sec = this.q('[data-fm-group="' + g + '"]');
      a.hidden = !k[g] || !sec || sec.hidden;
    }, this);
    return total;
  };

  Page.prototype.more = function (g) {
    var sec = this.q('[data-fm-group="' + g + '"]'), was = [];
    if (!sec) return;
    sec.querySelectorAll('.vms-fm__card').forEach(function (li) { if (li.hidden) was.push(li); });
    this.open[g] = true;
    var total = this.filter(), first = null;
    for (var i = 0; i < was.length && !first; i++) if (!was[i].hidden) first = was[i];
    var a = first && first.querySelector('.vms-fm__stretch');
    if (a) a.focus();
    this.announce(plural(total, 'mount shown.', 'mounts shown.'));
  };

  function init() {
    var F = window.VMSMountFit, data = F && readData(F);
    if (!data) { document.querySelectorAll('[data-vms-fm]').forEach(function (r) { if (r.removeAttribute) r.removeAttribute('data-fm-arrive'); }); return; }
    document.querySelectorAll('[data-vms-fm]').forEach(function (root) {
      if (root.vmsFm) return;
      root.vmsFm = new Page(root, data, F);
    });
  }

  window.VMSFindMounts = { init: init, holdEvents: HOLD_EV, firstShown: firstShown, tvId: tvId, headline: headline, fitRows: fitRows, shown: shown, moreText: moreText, stickyFits: stickyFits, srcset: srcset, sizes: SIZES, chipOf: chipOf, slug: SLUG, onChip: onChip, readLinks: readLinks, tvPages: tvPages };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
